import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';

const api = '/api/core/services';

const ListServices = () => (
  <ListResource
    {...{
      searchable: true,
      api,
      sort: { itemCode: 1 },
      actions: {
        fileImport: true,
        fileExport: true,
      },
      cols: [
        { key: 'itemCode', sortable: true, children: 'Item Code' },
        {
          key: 'active',
          getter(v) {
            return (
              <FA icon={v ? faEye : faEyeSlash} />
            );
          },
        },
        {
          key: 'orgId',
          sortable: true,
          children: 'Organization ID',
          getter: (v) => v.join(', '),
        },
        { key: 'description', sortable: true, children: 'Service Name' },
      ],
    }}
  />
);

export default ListServices;
